import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileUploader } from '../../../../node_modules/ng2-file-upload';
import { environment } from '../../../environments/environment';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { decode } from 'firebase-functions/lib/common/providers/https';
import { NgStyle, NgIf } from '@angular/common';
import { FileUploadModule } from 'ng2-file-upload';
import { LoaderComponent } from '../loader/loader.component';

@Component({
    selector: 'app-upload-avatar-image',
    templateUrl: './upload-avatar-image.component.html',
    styleUrls: ['./upload-avatar-image.component.scss'],
    imports: [NgStyle, NgIf, FileUploadModule, LoaderComponent, TranslatePipe],
    standalone: true
})
export class UploadAvatarImageComponent implements OnInit {

  @Input() image;
  @Input() editable = false;
  @Input() name;
  @Input() classes;
  @Output() imageUploaded = new EventEmitter;

  public loading = false;

  private URL = 'https://image-uploader-service.firebaseapp.com/upload';
  public errorMsg;
  public success = false;

  public uploader: FileUploader;
  public hasBaseDropZoneOver = false;
  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  constructor(private translate: TranslateService) { }

  ngOnInit() {
    this.uploader = new FileUploader({
      url: this.URL,
      method: 'POST',
      autoUpload: true,
      allowedMimeType: ['image/png', 'image/jpg', 'image/jpeg'],
      maxFileSize: 5 * 1024 * 1024, // 5 MB
      itemAlias: 'file'
    });

    this.uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => {
      this.onFileUploadSuccess(item, response);
    };
    this.uploader.onBeforeUploadItem = () => {
      this.onFileUploadStart();
    };
    this.uploader.onErrorItem = () => {
      this.onFileUploadError();
    };
    this.uploader.onAfterAddingFile = (file) => { file.withCredentials = false; };

    this.uploader.onWhenAddingFileFailed = (fileItem) => {
      this.errorMsg = this.translate.instant('GENERAL.fileTypeNotSupported');
    };
  }

  getImage(image) {
    if (image) {
      image += '?w=100';
      // escape parentheses
      image = image.replace(/[\(\)]/g, function (m) {
        return escape(m);
      });
      // escape whitespaces
      image = image.replace(/\s/g, '%20');
      return {'background-image': 'url(' + image + ')' };
    }
    return null;
  }

  removeImage() {
    this.imageUploaded.emit('');
  }

  onFileUploadStart() {
    this.errorMsg = null;
    this.loading = true;
  }

  onFileUploadSuccess(item, fileUrl) {
    const image = JSON.parse(fileUrl);
    this.imageUploaded.emit(image.data);
    this.loading = false;
  }

  onFileUploadError() {
    this.errorMsg = this.translate.instant('GENERAL.generalErrorMsg');
    this.loading = false;
  }

}
